export type CustomerAuthEndReason =
  | 'logout'
  | 'revoked'
  | 'expired'
  | 'consent'
  | 'idle';

export interface CustomerAuthLifecycleHooks {
  onSessionEnded: (reason: CustomerAuthEndReason) => void;
}

let hooks: CustomerAuthLifecycleHooks | null = null;

export function registerCustomerAuthLifecycleHooks(
  next: CustomerAuthLifecycleHooks
): () => void {
  hooks = next;
  return () => {
    if (hooks === next) {
      hooks = null;
    }
  };
}

export function notifySessionEnded(reason: CustomerAuthEndReason): void {
  hooks?.onSessionEnded(reason);
}
